import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import * as actions from '../../actions/index';
import * as _ from 'lodash';
import {get as _get} from 'lodash';
import {getData, LOGIN} from "../../util/storage";
//image
import vuepay_large_logo from '../../assets/images/vuepaylogonav@5x.png';
import loading_white from '../../assets/gif/loading_white.gif';
//internal js
import {isEmpty, vuepayAlert, vuePayLog} from "../../util/utility";
// import {, makeUserOnline} from "../util/utility";
import {checkIfTwoFactorAuth, checkIfTwoFactorAuthVerifyOtp} from "../../util/account_management";

class VerifyOTP extends Component {

    required = value => (value ? undefined : 'Required');

    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            resent_otp: false
        };
        this.verifyOTP = this.verifyOTP.bind(this);
        this.resendOTP = this.resendOTP.bind(this);
        this.handleKeyUp = this.keyUpHandler.bind(this, 'LoginInput');
    }

    /**
     * listener for OTP
     * @param refName
     * @param e
     */
    keyUpHandler(refName, e) {
        const target = e.srcElement || e.target;
        const maxLength = 1//target.attributes["maxLength"].value;
        const myLength = target.value.length;
        const attribute = parseInt(target.attributes.getNamedItem('data-field').value);

        if (myLength >= maxLength) {
            if (attribute !== 5) {
                document.getElementById("otp-number-" + (attribute + 1)).focus()
            }
        } else if (myLength === 0) {
            // Move to previous field if empty (user pressed backspace)
            if (attribute !== 1) {
                document.getElementById("otp-number-" + (attribute - 1)).focus()
            }
        }
    }

    componentDidMount() {
    }

    componentWillMount() {
        // redirectIfSessionExist((is_session_valid) => {
        //     if (is_session_valid) {
        //         this.props.history.push("/dashboard");
        //     }
        // });
    }

    componentWillReceiveProps(nextProps) {

        if (checkIfTwoFactorAuthVerifyOtp(nextProps)) {
            if (nextProps.account_management.twoFactorAuthVerifyOtp.status_code === 200) {
                const basePath = _get(this.props, 'location.state.basePath', '')

                vuepayAlert("success", nextProps.account_management.twoFactorAuthVerifyOtp.message, () => {

                    getData(LOGIN)
                        .then((data) => {
                            if (!isEmpty(data)) {
                                this.props.getUserDetails(data.token, data.api_token);
                                this.props.getFollowingList(data.token, data.api_token, "", "")
                            }

                            if (nextProps.location.state.isGolive) {
                                nextProps.history.push("/broadcaster/register",
                                    {
                                        country_code: _get(this.props, 'location.state.country_code', ''),
                                        mobile_number: _get(this.props, 'location.state.mobile_number', ''),
                                    }
                                )
                            } else {
                                if (nextProps.hasOwnProperty("location") &&
                                    nextProps.location.hasOwnProperty("state") &&
                                    nextProps.location.state.hasOwnProperty("parentPath") &&
                                    nextProps.location.state.parentPath.hasOwnProperty("basePath")) {

                                    nextProps.history.push(
                                        {
                                            pathname: _get(nextProps, 'location.state.parentPath.basePath', ''),
                                            search: _get(nextProps, 'location.state.parentPath.search', ''),
                                            state: {
                                                basePath: nextProps.location.state.parentPath.basePath,
                                                search: _get(nextProps, 'location.state.parentPath.search', '')
                                            }
                                        }
                                    );
                                } else {
                                    nextProps.history.push("/dashboard")
                                }
                            }
                        });

                    nextProps.resetTwoFactorAuthVerifyOtp();
                });
            } else {
                vuepayAlert("error", nextProps.account_management.twoFactorAuthVerifyOtp.message, () => {
                    // nextProps.resetRegister();
                });
            }

        }
        if (checkIfTwoFactorAuth(nextProps)) {
            if (nextProps.account_management.twoFactorAuth && nextProps.account_management.twoFactorAuth.status_code === 201) {

                vuepayAlert("success", nextProps.account_management.twoFactorAuth.message)
                nextProps.resetTwoFactorAuth();
            } else {
                vuepayAlert("error", nextProps.account_management.twoFactorAuth.message, () => {
                    nextProps.resetTwoFactorAuth();
                });
            }
        }
    }

    resendOTP() {

        const country_code = _get(this.props, 'location.state.country_code', '')
        const mobile_number = _get(this.props, 'location.state.mobile_number', '')
        const formData = new FormData();
        formData.append("country_code", country_code);
        formData.append("mobile_number", mobile_number);
        formData.append("device[platform]", this.props.device.platform);
        formData.append("device[name]", this.props.device.name);
        formData.append("device[version]", this.props.device.version);
        formData.append("device[ip]", this.props.device.ip);
        formData.append("device[id]", this.props.device.id);
        formData.append("device[app_version]", this.props.device.app_version);
        formData.append("device[device_token]", this.props.device.device_token);

        vuePayLog(__filename, "onSubmit :: data", formData);
        this.props.towFactorAuth(formData, this.props.location.state.token, this.props.location.state.api_token);
    }

    verifyOTP() {

        if (!this.props.account_management.isFetching) {
            let otp_number = [
                document.getElementById("otp-number-1").value,
                document.getElementById("otp-number-2").value,
                document.getElementById("otp-number-3").value,
                document.getElementById("otp-number-4").value,
                document.getElementById("otp-number-5").value
            ], otp = '';

            _.map(otp_number, (value) => {
                otp = `${otp}${value}`
            });

            //otp length has to be five digit
            if (otp.length === 5) {
                const formData = new FormData();
                formData.append("otp", otp);
                formData.append("device[platform]", this.props.device.platform);
                formData.append("device[name]", this.props.device.name);
                formData.append("device[version]", this.props.device.version);
                formData.append("device[ip]", this.props.device.ip);
                formData.append("device[id]", this.props.device.id);
                formData.append("device[app_version]", this.props.device.app_version);
                formData.append("device[device_token]", this.props.device.device_token);

                vuePayLog(__filename, "onSubmit :: data", formData);
                //dispatch an action (verifyOTP)
                this.props.twoFactorAuthVerifyOtp(this.props.location.state.token, this.props.location.state.api_token, formData);
                document.getElementsByClassName("modal-overlay")[0].style.display = "none";
            }
        }
    }

    render() {
        const { handleSubmit, location } = this.props;
        const basePath = _get(location, 'state.basePath', '')
        const country_code = _get(location, 'state.country_code', '')
        const mobile_number = _get(location, 'state.mobile_number', '')
        const phone_number_validated = !(_get(this.props, 'location.state.phone_number_validated', false))


        return (
            <div>
                <main role="main" className="">
                    <div className="login-container">
                        <div className="popup-header">
                            {/* commenting below code as client request to remove close button from otp screen */}
                            {/* <button type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    document.getElementsByClassName("modal-overlay")[0].style.display = "none";
                                    // this.props.history.push(basePath)
                                    this.props.history.push(
                                        {
                                            pathname: this.props.location.state.parentPath ? this.props.location.state.parentPath.basePath : this.props.location.state.basePath,
                                            search: this.props.location.state.parentPath ? this.props.location.state.parentPath.search : this.props.location.state.search,
                                            state: {
                                                basePath: this.props.location.state.parentPath ? this.props.location.state.parentPath.basePath : this.props.location.state.basePath,
                                                search: this.props.location.state.parentPath ? this.props.location.state.parentPath.search : this.props.location.state.search
                                            }
                                        }
                                    );
                                }
                                }
                            >
                                <img alt={"close-icon"} src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"} />
                            </button> */}

                        </div>
                        <div className="row" style={{ position: "relative" }}>
                            <div className="col-md-6 bg-primary d-flex align-items-center text-center"
                                style={{ borderRight: '1px solid #e7e7e7' }}>
                                <img src={vuepay_large_logo} alt={"VuePay"} className="img-fluid" />
                            </div>
                            <div className="col-md-6 bg-white d-flex align-items-center">
                                <div>
                                    <div className="modal-body">
                                        <h4 className="mb-4">We have sent a code
                                            to {country_code + ' ' + '' + mobile_number} please
                                            enter it below {
                                                phone_number_validated && <Link
                                                    to={{
                                                        pathname: '/verify-mobile',

                                                        state: {
                                                            "basePath": basePath,
                                                            api_token: this.props.location.state.api_token,
                                                            token: this.props.location.state.token,
                                                            parentPath: {
                                                                basePath: this.props.location.state.parentPath ? this.props.location.state.parentPath.basePath : this.props.location.state.basePath,
                                                                search: this.props.location.state.parentPath ? this.props.location.state.parentPath.search : this.props.location.state.search,
                                                            }
                                                        }
                                                    }}
                                                    className="changeNumber"
                                                    role="button">(Change Mobile number)</Link>
                                            }</h4>


                                        {/*<p>Verification Code</p>*/}


                                        <ul className="otp-verify" onKeyUp={this.handleKeyUp} ref="LoginInput">
                                            <li><input className="otp-number" id="otp-number-1" data-field="1"
                                                type="tel" maxLength="1" /></li>
                                            <li><input className="otp-number" id="otp-number-2" data-field="2"
                                                type="tel" maxLength="1" /></li>
                                            <li><input className="otp-number" id="otp-number-3" data-field="3"
                                                type="tel" maxLength="1" /></li>
                                            <li><input className="otp-number" id="otp-number-4" data-field="4"
                                                type="tel" maxLength="1" /></li>
                                            <li><input className="otp-number" id="otp-number-5" data-field="5"
                                                type="tel" maxLength="1" /></li>
                                        </ul>
                                    </div>
                                    <div className="mt-4 text-center">
                                        <button className="btn btn-primary" onClick={this.verifyOTP}>
                                            {
                                                this.props.account_management.isFetching
                                                    ?
                                                    <img src={loading_white} alt={"Loading"} width={26} height={26} />
                                                    :
                                                    'VERIFY'
                                            }
                                        </button>
                                    </div>
                                    <div className="mt-4 text-center">
                                        <button type="button" className="btn btn-link" onClick={this.resendOTP}>Re-send
                                        OTP
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
        account_management: state.account_management,
        device: state.device.payload,
    };
}


// You have to connect() to any reducers that you wish to connect to yourself
VerifyOTP = connect(
    mapStateToProps, // pull initial values from account reducer
    actions // bind account loading action creator
)(VerifyOTP)

export default VerifyOTP